export default __webpack_public_path__ + "static/floor1_image4-pc-8d2350fc945ecaa81b5b132fa42221bd.png";